import { render } from "./PhotoEveryoneDayTab.vue?vue&type=template&id=4541290f"
import script from "./PhotoEveryoneDayTab.vue?vue&type=script&lang=js"
export * from "./PhotoEveryoneDayTab.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__